import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app/App";
import { subscribeToSession } from "./api/client";
import "./app/global.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Admin data is small and the single admin is the only writer.
      staleTime: 15_000,
      retry: (attempt, error) => {
        const status = (error as { status?: number }).status;
        // Never retry auth/validation failures; they will not fix themselves.
        if (status && status >= 400 && status < 500) return false;
        return attempt < 2;
      },
    },
  },
});

subscribeToSession((authenticated) => {
  if (!authenticated) queryClient.clear();
});

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
